"use client";

export {
  Chevron,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
} from "./deprecated/Chevron";
